import React, { useEffect } from "react";
import { ChevronRight } from "lucide-react";
import styles from "./GestionHub.module.scss";
import { GESTION_HUB_GROUPS } from "./gestionHubConfig.ts";
import type { ProfileGestionSection } from "../../../../utils/navigationHelpers.ts";

interface GestionHubProps {
  onSelectSection: (section: ProfileGestionSection) => void;
  setInfoReady: (ready: boolean) => void;
}

const GestionHub: React.FC<GestionHubProps> = ({ onSelectSection, setInfoReady }) => {
  useEffect(() => {
    setInfoReady(true);
  }, [setInfoReady]);

  return (
    <div className={styles.hub}>
      <p className={styles.intro}>
        Elegí qué querés administrar. Podés volver acá desde cualquier sección.
      </p>
      {GESTION_HUB_GROUPS.map((group) => (
        <section key={group.id} className={styles.group} aria-labelledby={`gestion-group-${group.id}`}>
          <h2 id={`gestion-group-${group.id}`} className={styles.groupTitle}>
            {group.label}
          </h2>
          <div className={styles.grid}>
            {group.items.map((item) => {
              const Icon = item.icon;
              if (item.teaser) {
                return (
                  <div
                    key={item.section}
                    className={`${styles.card} ${styles.cardTeaser}`}
                    aria-disabled="true"
                  >
                    <span className={styles.iconWrap} aria-hidden>
                      <Icon size={22} />
                    </span>
                    <div className={styles.cardBody}>
                      <div className={styles.cardTitleRow}>
                        <p className={styles.cardTitle}>{item.title}</p>
                        <span className={styles.teaserBadge}>Próximamente</span>
                      </div>
                      <p className={styles.cardDescription}>{item.description}</p>
                    </div>
                  </div>
                );
              }
              return (
                <button
                  key={item.section}
                  type="button"
                  className={styles.card}
                  onClick={() => onSelectSection(item.section)}
                >
                  <span className={styles.iconWrap} aria-hidden>
                    <Icon size={22} />
                  </span>
                  <div className={styles.cardBody}>
                    <p className={styles.cardTitle}>{item.title}</p>
                    <p className={styles.cardDescription}>{item.description}</p>
                  </div>
                  <ChevronRight className={styles.chevron} size={20} aria-hidden />
                </button>
              );
            })}
          </div>
        </section>
      ))}
    </div>
  );
};

export default GestionHub;
